<script>
  /**
   * @typedef {Object} Props
   * @property {boolean} [isLeft]
   * @property {any} [onclick]
   * @property {boolean} [disabled]
   */

  /** @type {Props} */
  let { isLeft = false, onclick = () => {}, disabled = false } = $props();
</script>

<button class="wc-btn__nav" {disabled} onclick={onclick}>
  <span class="wc-hidden--visually">{isLeft ? 'previous' : 'next'}</span>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="26.415"
    viewBox="0 0 16 26.415"
    aria-hidden="true">
    {#if isLeft}
      <path
        d="M643.109,512.6l-12.24-10.934a2.9,2.9,0,0,1,3.868-4.33l8.372,7.48,8.372-7.48a2.9,2.9,0,0,1,3.866,4.33Z"
        transform={`translate(512.6 -629.901) rotate(90)`} />
    {:else}
      <path
        d="M643.109,512.6l-12.24-10.934a2.9,2.9,0,0,1,3.868-4.33l8.372,7.48,8.372-7.48a2.9,2.9,0,0,1,3.866,4.33Z"
        transform="translate(-496.6 656.316) rotate(-90)" />
    {/if}
  </svg>
</button>
